// src/config/loginBackground.js
// ======================================================================
// 🎨 مظهر صفحات الدخول والتسجيل والاستعادة
// غيّر القيم هنا واحفظ الملف — يتحدث المظهر فورًا.
// أو بدون تعديل الكود، في ملف .env:
//   REACT_APP_LOGIN_BG=emerald
//   REACT_APP_LOGIN_LAYOUT=center
// ======================================================================

export const LOGIN_BACKGROUND = {
  // التخطيط:
  //   'framed' = صفحة فاتحة وفي منتصفها إطار: النموذج + لوحة دعائية بجانبه (مثل الأنظمة الاحترافية)
  //   'split'  = الشاشة مقسومة نصفين: لوحة الهوية بكامل الارتفاع + النموذج
  //   'center' = النموذج في منتصف الشاشة فوق الخلفية الملونة
  // (على الجوال تظهر البطاقة وحدها تلقائيًا)
  layout: 'framed',

  // صورتك الدعائية الخاصة للوحة الجانبية (framed و split)
  // null = تصميم مولّد تلقائيًا من الخلفية المختارة + نصوص brand بالأسفل
  // مثال: '/backgrounds/login-banner.jpg'  ← ضعها في public/backgrounds/ (يُفضّل 1200×900)
  bannerImage: null,

  // الخلفية: aurora | midnight | emerald | ocean | sunset | light | image
  preset: 'aurora',

  // يُستخدم عند preset: 'image'
  // ضع الصورة في: public/backgrounds/login.jpg (يُفضّل 1920×1080 وأقل من 400KB)
  imageUrl: '/backgrounds/login.jpg',
  imageOverlay: 0.6, // تعتيم الصورة: 0 بدون — 1 معتمة تمامًا

  animated: true, // حركة الإضاءة البطيئة

  // زر تجربة المظاهر في زاوية الشاشة — اجعلها false قبل النشر للعملاء
  allowSwitcher: true,

  // ── محتوى لوحة الهوية (في التخطيط المقسوم) ──
  brand: {
    name: 'برنامج أرباح المحاسبي  Profit Erp',
    tagline: 'أدِر أعمالك بثقة،\nوفواتيرك بامتثال كامل',
    description: 'نظام محاسبي سحابي متكامل للمبيعات والمخزون والحسابات، مصمم للمنشآت في المملكة.',
    features: [
      'فوترة إلكترونية متوافقة مع هيئة الزكاة والضريبة',
      'إدارة الفروع والمخازن ونقاط البيع',
      'تقارير مالية لحظية من أي مكان',
    ],
    showStatsCard: true, // بطاقة الإحصائية الزخرفية
  },
};

// ──────────────────────────────────────────────────────────────────────
// الخلفيات الجاهزة — عدّلها أو أضف خلفية جديدة بنفس الشكل
//   base         : التدرج الأساسي
//   glows        : ألوان الإضاءات الناعمة (حتى 3)
//   pattern      : null | 'dots' | 'grid' | 'islamic'
//   patternColor : لون النقش
//   accent       : لون التمييز (الأيقونات والعلامات في لوحة الهوية)
//   dark         : true للخلفيات الداكنة
// ──────────────────────────────────────────────────────────────────────
export const BACKGROUND_PRESETS = {
  aurora: {
    label: 'شفق نيلي',
    base: 'radial-gradient(1200px 700px at 85% -10%, #312e81 0%, transparent 60%), linear-gradient(160deg, #0b1023 0%, #12103a 55%, #0b1023 100%)',
    glows: ['rgba(99,102,241,.55)', 'rgba(20,184,166,.35)', 'rgba(168,85,247,.40)'],
    pattern: 'grid',
    patternColor: 'rgba(255,255,255,.045)',
    accent: '#818cf8',
    dark: true,
  },
  midnight: {
    label: 'ليلي',
    base: 'radial-gradient(1000px 600px at 50% -20%, #1e3a8a 0%, transparent 60%), #070b16',
    glows: ['rgba(59,130,246,.45)', 'rgba(14,165,233,.30)'],
    pattern: 'dots',
    patternColor: 'rgba(148,163,184,.14)',
    accent: '#60a5fa',
    dark: true,
  },
  emerald: {
    label: 'زمردي بنقش إسلامي',
    base: 'radial-gradient(1100px 700px at 15% 110%, #065f46 0%, transparent 60%), linear-gradient(150deg, #02201a 0%, #03342a 55%, #022019 100%)',
    glows: ['rgba(16,185,129,.45)', 'rgba(234,179,8,.22)', 'rgba(20,184,166,.30)'],
    pattern: 'islamic',
    patternColor: 'rgba(255,255,255,.07)',
    accent: '#34d399',
    dark: true,
  },
  ocean: {
    label: 'محيطي',
    base: 'radial-gradient(1000px 700px at 90% 0%, #075985 0%, transparent 60%), linear-gradient(170deg, #06202f 0%, #0a2d42 50%, #071621 100%)',
    glows: ['rgba(56,189,248,.45)', 'rgba(45,212,191,.30)'],
    pattern: 'dots',
    patternColor: 'rgba(255,255,255,.09)',
    accent: '#38bdf8',
    dark: true,
  },
  sunset: {
    label: 'غروب',
    base: 'radial-gradient(1000px 700px at 100% 100%, #9a3412 0%, transparent 55%), linear-gradient(150deg, #1a1033 0%, #3b0f45 55%, #24102e 100%)',
    glows: ['rgba(249,115,22,.45)', 'rgba(236,72,153,.38)', 'rgba(250,204,21,.18)'],
    pattern: null,
    accent: '#fb923c',
    dark: true,
  },
  light: {
    label: 'فاتح',
    base: 'linear-gradient(150deg, #eef2ff 0%, #f8fafc 50%, #ecfdf5 100%)',
    glows: ['rgba(99,102,241,.30)', 'rgba(16,185,129,.22)', 'rgba(236,72,153,.15)'],
    pattern: 'grid',
    patternColor: 'rgba(15,23,42,.05)',
    accent: '#4f46e5',
    dark: false,
  },
  image: {
    label: 'صورة مخصصة',
    base: '#0b1023',
    glows: ['rgba(99,102,241,.30)'],
    pattern: null,
    image: true,
    accent: '#a5b4fc',
    dark: true,
  },
};